import carouselNavigationVariables from './carouselNavigationVariables';

export default carouselNavigationVariables;
